import React from "react"
import GoogleMapMBP from "./GoogleMap"

interface Props {
	mapApiKey:string|null
	servicePartnersRawList: any[]
	isPdp?: boolean
}

const ServiceCentersMap:React.FC<Props> = ({mapApiKey, servicePartnersRawList, isPdp = false}) => {
	const locations = removeNullInArr(formatLocations(servicePartnersRawList))

	return (
		<>
			{mapApiKey && locations.length > 0 && <>
				<GoogleMapMBP mapApiKey={mapApiKey}
					locations={locations}
					isPdp={isPdp} />
			</>}
		</>
	)
}

export default ServiceCentersMap

const formatLocations = servicePartnersData => servicePartnersData.map((item, index) => {
	if (!item.lat || !item.lng || !item.zip) {
		return null
	}

	return {
		id: index,
		name: item.name,
		lat: parseFloat(item.lat),
		lng: parseFloat(item.lng),
		zip: item.zip
	}
})

const removeNullInArr = arr => arr.filter(item => item !== null)
